import { apiDefaultWithoutTokenWithUrlencodedType } from "./api";

const prefix = "https://www.trplus.com.tw";

export const apiPostSimpleProduct = (data) =>
    apiDefaultWithoutTokenWithUrlencodedType["post"](
        `${prefix}/rest/v2/trplus/productList?skus=${data.toString()}`
    );
// 存 json
export const apiPostSaveStatus = (data) =>
    apiDefaultWithoutTokenWithUrlencodedType["post"](
        `/situationSales/setSituationSales`,
        data
    );
// 取 josn
export const apiGetSaveStatus = (data) =>
    apiDefaultWithoutTokenWithUrlencodedType["get"](
        `/situationSales/getSituationSales`,
        data
    );
// 加入購物車
export const apiPostAddToCart = (data) =>
    apiDefaultWithoutTokenWithUrlencodedType["post"](`/cart/add`, data);
